/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { object } from 'prop-types';
import ThreeUpMobile from './Mobile/ThreeUpMobile';
import ThreeUpDesktop from './Desktop/ThreeUpDesktop';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import uniqueId from '../../../helpers/contentstack/uniqueId';

export class ThreeUpRow extends PureComponent {
    render() {
        const { data } = this.props;
        const deviceType = data.reference?.[0]?.device;
        if (data.reference?.[0].panel_row?.[0].panel?.reference?.[0]) {
            const { dataUniqueId } = uniqueId(data.reference[0]?.unique_selector);
            return (
                <div className="threeup_block" data-uniqueid={dataUniqueId}>
                    <DesktopMobile
                        desktop={() => ((deviceType === 'Desktop' || deviceType ===  'Both') ? <ThreeUpDesktop data={data} /> : null)}
                        mobile={() => ((deviceType === 'Mobile' || deviceType === 'Both') ? <ThreeUpMobile data={data} /> : null)}

                        data-uniqueid={dataUniqueId}
                    />
                </div>
            );
        }
        return <></>;
    }
}

ThreeUpRow.propTypes = {
    data: object.isRequired,
};

export default ThreeUpRow;
